/**
 * RYFE — Whiteboard frontend config.
 * The backend base URL is configurable at build time via VITE_APP_RYFE_API;
 * default is same-origin ("") so a single-origin deployment needs no config.
 */

export const RYFE_API_BASE: string =
  (import.meta.env.VITE_APP_RYFE_API as string | undefined)?.replace(
    /\/$/,
    "",
  ) ?? "";

/** Build an absolute API URL from a path like "/api/branding". */
export const apiUrl = (path: string): string =>
  `${RYFE_API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

/** WebSocket base derived from the API base (or the current origin). */
export const wsBase = (): string => {
  const base =
    RYFE_API_BASE ||
    (typeof window !== "undefined" ? window.location.origin : "");
  return base.replace(/^http/, "ws");
};
